module.exports = __webpack_public_path__ + "static/media/4-9.a79e1784.png";